{
  "accountHealth": "Account Health",
  "activeCopies": "सक्रिय कॉपी",
  "addFavorite": "☆ Add Favorite",
  "affectedCoins": "प्रभावित कॉइन",
  "aiAlert": "AI अलर्ट",
  "aiArbitrageScanner": "AI आर्बिट्राज स्कैनर",
  "aiCenter": "AI केंद्र",
  "aiConfidence": "AI विश्वास",
  "aiConfidenceMeter": "AI विश्वास मीटर",
  "aiCopyTrading": "AI कॉपी ट्रेडिंग",
  "aiFinalDecision": "AI अंतिम निर्णय",
  "aiGridTrading": "AI Grid Trading",
  "aiLaunchpad": "AI लॉन्चपैड",
  "aiMarketNews": "AI बाजार समाचार",
  "aiMarketScanner": "AI मार्केट स्कैनर",
  "aiNews": "AI News",
  "aiPortfolioManager": "AI पोर्टफोलियो मैनेजर",
  "aiProfitCalculator": "AI प्रॉफिट कैलकुलेटर",
  "aiRankedTrader": "AI-रैंक किया गया ट्रेडर",
  "aiRebalance": "AI पुनर्संतुलन",
  "aiRecommendation": "AI सिफारिश",
  "aiRecommendations": "AI सिफारिशें",
  "aiResult": "AI परिणाम",
  "aiRiskEngine": "AI जोखिम इंजन",
  "aiRiskLevel": "AI जोखिम स्तर",
  "aiRiskManager": "AI रिस्क मैनेजर",
  "aiScanResult": "AI स्कैन परिणाम",
  "aiScore": "AI स्कोर",
  "aiSignal": "AI सिग्नल",
  "aiSmartAlerts": "AI Smart Alerts",
  "aiSubtitle": "AI-संचालित ट्रेडिंग, विश्लेषण, स्वचालन और जोखिम प्रबंधन।",
  "aiSuggestions": "AI सुझाव",
  "aiTitle": "कृत्रिम बुद्धिमत्ता",
  "aiTrader": "AI ट्रेडर",
  "aiTradingAssistant": "AI ट्रेडिंग असिस्टेंट",
  "aiTradingAssistantSubtitle": "वास्तविक समय AI बाजार संकेत, भावना और रुझान विश्लेषण।",
  "aiTrustScore": "AI Trust Score",
  "aiWhaleAlerts": "AI व्हेल अलर्ट",
  "aiWhaleHeatmap": "AI व्हेल हीटमैप",
  "aiWhaleTracker": "AI Whale Tracker",
  "alertType": "अलर्ट प्रकार",
  "allCategories": "सभी श्रेणियां",
  "allImpact": "सभी प्रभाव",
  "allImpacts": "सभी प्रभाव",
  "allSentiments": "सभी भावनाएं",
  "allSymbols": "सभी प्रतीक",
  "apply": "Apply",
  "applySafeModeScan": "सेफ-मोड स्कैन लागू करें",
  "applying": "लागू किया जा रहा है...",
  "arbitrageOpportunities": "आर्बिट्राज अवसर",
  "assetAllocation": "संपत्ति आवंटन",
  "audit": "ऑडिट",
  "backendPreviewAlerts": "सहेजे जाने से पहले अलर्ट यहां पूर्वावलोकन में दिखाए जाते हैं।",
  "backendWillSaveAfterApi": "बैकएंड द्वारा अनुरोध की पुष्टि होने के बाद यह सहेजा जाएगा।",
  "baseCoin": "आधार कॉइन",
  "breaking": "ब्रेकिंग",
  "btcDominance": "BTC डोमिनेंस",
  "btcVolatilityNews": "BTC अस्थिरता समाचार",
  "buyDecision": "खरीदें",
  "buyExchange": "खरीद एक्सचेंज",
  "buyPressure": "Buy Pressure",
  "buyPrice": "खरीद मूल्य",
  "buySignal": "खरीदें",
  "buyStrength": "खरीद शक्ति",
  "buyVolume": "खरीद वॉल्यूम",
  "buyZone": "Buy Zone",
  "calculate": "गणना करें",
  "calculateAiProfit": "AI लाभ की गणना करें",
  "calculating": "गणना की जा रही है...",
  "capitalGreaterThanZero": "पूंजी शून्य से अधिक होनी चाहिए।",
  "capitalProtection": "Capital Protection",
  "category": "श्रेणी",
  "clear": "साफ़ करें",
  "communityScore": "समुदाय स्कोर",
  "compoundDays": "चक्रवृद्धि दिन",
  "compoundResult": "चक्रवृद्धि परिणाम",
  "condition": "शर्त",
  "confidence": "Confidence",
  "confidenceScore": "कॉन्फिडेंस स्कोर",
  "contractSafety": "Contract Safety",
  "copyTradeIdMissing": "कॉपी ट्रेड ID गुम है।",
  "copyTrader": "कॉपी ट्रेडर",
  "copyTradingStarted": "कॉपी ट्रेडिंग शुरू हुई।",
  "copyTradingStopped": "कॉपी ट्रेडिंग रोकी गई।",
  "createAiAlert": "AI अलर्ट बनाएं",
  "createAiOpportunity": "AI अवसर बनाएं",
  "createAiWhaleAlert": "AI व्हेल अलर्ट बनाएं",
  "createGridStrategy": "ग्रिड रणनीति बनाएं",
  "createLaunchpadProject": "लॉन्चपैड प्रोजेक्ट बनाएं",
  "createOpportunity": "अवसर बनाएं",
  "createSmartAlert": "स्मार्ट अलर्ट बनाएं",
  "createWhaleAlert": "व्हेल अलर्ट बनाएं",
  "created": "बनाया गया",
  "creating": "बनाया जा रहा है...",
  "currentPrice": "Current Price",
  "currentRiskScore": "वर्तमान जोखिम स्कोर",
  "dailyProfit": "दैनिक लाभ",
  "delete": "Delete",
  "deleteCalculationConfirm": "क्या आप वाकई इस गणना को हटाना चाहते हैं?",
  "deleteMarketScanConfirm": "क्या आप वाकई इस मार्केट स्कैन को हटाना चाहते हैं?",
  "detected": "पता चला",
  "diversification": "विविधीकरण",
  "emailAlert": "ईमेल अलर्ट",
  "enableCompoundingProjection": "चक्रवृद्धि प्रक्षेपण सक्षम करें",
  "enterCopyAmountFor": "के लिए कॉपी राशि दर्ज करें",
  "enterNewsTitle": "समाचार शीर्षक दर्ज करें",
  "exitPrice": "निकास मूल्य",
  "expectedLoss": "Expected Loss",
  "expectedProfit": "Expected Profit",
  "extremeFear": "अत्यधिक भय",
  "extremeGreed": "अत्यधिक लालच",
  "failedCalculateProfit": "लाभ की गणना करने में विफल।",
  "failedCreateArbitrageOpportunity": "आर्बिट्राज अवसर बनाने में विफल।",
  "failedCreateGridStrategy": "ग्रिड रणनीति बनाने में विफल।",
  "failedCreateLaunchpadProject": "लॉन्चपैड प्रोजेक्ट बनाने में विफल।",
  "failedCreateSmartAlert": "स्मार्ट अलर्ट बनाने में विफल।",
  "failedDeleteCalculation": "गणना हटाने में विफल।",
  "failedDeleteMarketScan": "मार्केट स्कैन हटाने में विफल।",
  "failedLoadAiNews": "AI समाचार लोड करने में विफल।",
  "failedLoadArbitrageScanner": "आर्बिट्राज स्कैनर लोड करने में विफल।",
  "failedLoadGridTrading": "ग्रिड ट्रेडिंग लोड करने में विफल।",
  "failedLoadLaunchpad": "लॉन्चपैड लोड करने में विफल।",
  "failedLoadMarketScanner": "मार्केट स्कैनर लोड करने में विफल।",
  "failedLoadProfitCalculator": "लाभ कैलकुलेटर लोड करने में विफल।",
  "failedLoadRiskManager": "जोखिम प्रबंधक लोड करने में विफल।",
  "failedLoadSmartAlerts": "स्मार्ट अलर्ट लोड करने में विफल।",
  "failedLoadTrustScore": "ट्रस्ट स्कोर लोड करने में विफल।",
  "failedLoadWhaleHeatmap": "व्हेल हीटमैप लोड करने में विफल।",
  "failedLoadWhaleTracker": "व्हेल ट्रैकर लोड करने में विफल।",
  "failedLogins": "विफल लॉगिन",
  "failedMarkAlertRead": "अलर्ट को पढ़ा हुआ चिह्नित करने में विफल।",
  "failedNewsAction": "यह कार्रवाई पूरी करने में विफल।",
  "failedRefreshRiskProfile": "जोखिम प्रोफ़ाइल रीफ़्रेश करने में विफल।",
  "failedRunMarketScan": "मार्केट स्कैन चलाने में विफल।",
  "failedStartCopyTrading": "कॉपी ट्रेडिंग शुरू करने में विफल।",
  "failedStopCopyTrading": "कॉपी ट्रेडिंग रोकने में विफल।",
  "failedSubmitNews": "समाचार सबमिट करने में विफल।",
  "failedSyncSymbol": "प्रतीक सिंक करने में विफल।",
  "failedToLoadData": "AI डेटा लोड करने में विफल।",
  "failedUpdateFavorite": "पसंदीदा अपडेट करने में विफल।",
  "favorite": "★ Favorite",
  "fear": "भय",
  "fearGreedGauge": "भय और लालच गेज",
  "fearGreedIndex": "Fear & Greed Index",
  "featuredLaunch": "विशेष लॉन्च",
  "generate": "जनरेट करें",
  "generateAiGrid": "AI ग्रिड जनरेट करें",
  "generating": "जनरेट हो रहा है...",
  "greed": "लालच",
  "gridCount": "ग्रिड गणना",
  "gridStrategies": "ग्रिड रणनीतियां",
  "grids": "ग्रिड",
  "hardCap": "हार्ड कैप",
  "heat": "हीट",
  "high": "उच्च",
  "highPriority": "उच्च प्राथमिकता",
  "highRisk": "उच्च जोखिम",
  "highRiskDetected": "उच्च जोखिम का पता चला।",
  "highWithdrawals": "उच्च निकासी",
  "holderScore": "Holder Score",
  "impact": "प्रभाव",
  "investment": "निवेश",
  "kycCompleted": "KYC पूर्ण",
  "lastScan": "अंतिम स्कैन",
  "lastUpdated": "लास्ट अपडेटेड",
  "latestAlert": "नवीनतम अलर्ट",
  "launchpadProjects": "लॉन्चपैड प्रोजेक्ट्स",
  "liquidityScore": "Liquidity Score",
  "liveAiMarketSignal": "लाइव AI बाजार संकेत",
  "liveVolume": "लाइव वॉल्यूम",
  "liveWhaleAlerts": "लाइव व्हेल अलर्ट",
  "loading": "लोड हो रहा है...",
  "loadingAi": "AI डेटा लोड हो रहा है...",
  "loadingAiNews": "AI समाचार लोड हो रहे हैं...",
  "loadingArbitrageScanner": "आर्बिट्राज स्कैनर लोड हो रहा है...",
  "loadingGridTrading": "ग्रिड ट्रेडिंग लोड हो रही है...",
  "loadingLaunchpad": "लॉन्चपैड लोड हो रहा है...",
  "loadingMarketScanner": "मार्केट स्कैनर लोड हो रहा है...",
  "loadingProfitCalculator": "लाभ कैलकुलेटर लोड हो रहा है...",
  "loadingRiskManager": "जोखिम प्रबंधक लोड हो रहा है...",
  "loadingSmartAlerts": "स्मार्ट अलर्ट लोड हो रहे हैं...",
  "loadingTrustScore": "ट्रस्ट स्कोर लोड हो रहा है...",
  "loadingWhaleAlerts": "व्हेल अलर्ट लोड हो रहे हैं...",
  "loadingWhaleHeatmap": "व्हेल हीटमैप लोड हो रहा है...",
  "loadingWhaleTracker": "व्हेल ट्रैकर लोड हो रहा है...",
  "lowRisk": "कम जोखिम",
  "lowRiskDetected": "कम जोखिम का पता चला।",
  "lowerPrice": "निम्न मूल्य",
  "markRead": "पढ़ा हुआ चिह्नित करें",
  "marketSentiment": "मार्केट सेंटीमेंट",
  "marketType": "बाजार प्रकार",
  "marketWeaknessDetected": "बाजार में कमजोरी का पता चला।",
  "maxBuy": "अधिकतम खरीद",
  "medium": "मध्यम",
  "mediumRisk": "Medium Risk",
  "mediumRiskDetected": "मध्यम जोखिम का पता चला।",
  "minBuy": "न्यूनतम खरीद",
  "minimumWhaleAmountUsd": "न्यूनतम व्हेल राशि (USD)",
  "moderateTrend": "मध्यम रुझान",
  "monthlyProfit": "मासिक लाभ",
  "myCopyTrades": "मेरी कॉपी ट्रेड्स",
  "myMarketScanHistory": "मेरा मार्केट स्कैन इतिहास",
  "myProfitHistory": "मेरा लाभ इतिहास",
  "neutralDecision": "तटस्थ",
  "neutralMarketConditions": "तटस्थ बाजार स्थितियां।",
  "neutralSignal": "तटस्थ",
  "newsFeed": "समाचार फ़ीड",
  "noActiveCopyTrades": "कोई सक्रिय कॉपी ट्रेड नहीं।",
  "noAiNewsFound": "कोई AI समाचार नहीं मिला।",
  "noAlertsFound": "कोई अलर्ट नहीं मिला।",
  "noCalculationYet": "अभी तक कोई गणना नहीं।",
  "noDate": "कोई तिथि नहीं",
  "noGridStrategiesFound": "कोई ग्रिड रणनीति नहीं मिली।",
  "noHeatmapDataFound": "कोई हीटमैप डेटा नहीं मिला।",
  "noLaunchpadProjectsFound": "कोई लॉन्चपैड प्रोजेक्ट नहीं मिला।",
  "noOpportunitiesFound": "कोई अवसर नहीं मिला।",
  "noPinnedNews": "कोई पिन किया गया समाचार नहीं।",
  "noRecommendationYet": "अभी तक कोई सिफारिश नहीं।",
  "noRiskHistoryYet": "अभी तक कोई जोखिम इतिहास नहीं।",
  "noSavedCalculations": "कोई सहेजी गई गणना नहीं।",
  "noSavedScans": "कोई सहेजा गया स्कैन नहीं।",
  "noScanYet": "अभी तक कोई स्कैन नहीं।",
  "noTrustScoresFound": "कोई ट्रस्ट स्कोर नहीं मिला।",
  "noWhaleTransactionsFound": "कोई व्हेल लेनदेन नहीं मिला।",
  "noWhaleWalletsDetected": "कोई व्हेल वॉलेट नहीं मिला।",
  "notScannedYet": "अभी तक स्कैन नहीं हुआ।",
  "p2pDisputes": "P2P विवाद",
  "pinned": "पिन किया गया",
  "pinnedNews": "पिन किए गए समाचार",
  "portfolioExposure": "Portfolio Exposure",
  "portfolioRebalancedSuccessfully": "पोर्टफोलियो सफलतापूर्वक पुनर्संतुलित किया गया।",
  "position": "पोज़िशन",
  "priority": "प्राथमिकता",
  "processing": "प्रोसेसिंग...",
  "projectName": "प्रोजेक्ट का नाम",
  "raised": "जुटाई गई राशि",
  "raisedAmount": "जुटाई गई राशि",
  "rebalanceFailed": "पुनर्संतुलन विफल रहा।",
  "records": "रिकॉर्ड",
  "refresh": "रिफ्रेश",
  "refreshAiScan": "AI Scan Refresh करें",
  "risk": "जोखिम",
  "riskFactors": "जोखिम कारक",
  "riskHistory": "जोखिम इतिहास",
  "riskLevel": "रिस्क लेवल",
  "riskReward": "Risk / Reward",
  "riskRewardRatio": "जोखिम/इनाम अनुपात",
  "riskScore": "रिस्क स्कोर",
  "roi": "आरओआई",
  "runAiMarketScan": "AI मार्केट स्कैन चलाएं",
  "runAiScan": "AI Scan चलाएं",
  "safe": "Safe",
  "scan": "स्कैन करें",
  "scanning": "स्कैन हो रहा है...",
  "searchAiNews": "AI समाचार खोजें...",
  "searchWalletOrSymbol": "वॉलेट या प्रतीक खोजें...",
  "sellDecision": "बेचें",
  "sellExchange": "बिक्री एक्सचेंज",
  "sellPressure": "Sell Pressure",
  "sellPrice": "बिक्री मूल्य",
  "sellSignal": "बेचें",
  "sellVolume": "बिक्री वॉल्यूम",
  "sellZone": "Sell Zone",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "signal": "सिग्नल",
  "signalStrength": "सिग्नल शक्ति",
  "smartAlerts": "स्मार्ट अलर्ट",
  "softCap": "सॉफ्ट कैप",
  "source": "स्रोत",
  "sourceUrl": "स्रोत URL",
  "spread": "स्प्रेड",
  "stop": "रोकें",
  "strongBuyDecision": "मजबूत खरीद",
  "strongBuyOpportunity": "मजबूत खरीद अवसर।",
  "strongTrend": "मजबूत रुझान",
  "submitAiNews": "AI समाचार सबमिट करें",
  "submitNews": "समाचार सबमिट करें",
  "submitNewsForAiAnalysis": "AI विश्लेषण के लिए समाचार सबमिट करें।",
  "suggestedCopy": "सुझाई गई कॉपी राशि",
  "suggestedLeverage": "सुझाया गया लीवरेज",
  "summary": "सारांश",
  "suspiciousActivity": "संदिग्ध गतिविधि",
  "sync": "Sync",
  "syncing": "सिंक हो रहा है...",
  "targetPrice": "लक्ष्य मूल्य",
  "telegramAlert": "टेलीग्राम अलर्ट",
  "timeframe": "समयसीमा",
  "title": "शीर्षक",
  "titleSummaryRequired": "शीर्षक और सारांश आवश्यक हैं।",
  "tokenPrice": "टोकन मूल्य",
  "topGainers": "टॉप गेनर्स",
  "topGridStrategy": "शीर्ष ग्रिड रणनीति",
  "topLosers": "टॉप लूज़र्स",
  "topOpportunity": "शीर्ष अवसर",
  "topWhaleWallets": "शीर्ष व्हेल वॉलेट",
  "totalAlerts": "कुल अलर्ट",
  "totalCopied": "कुल कॉपी किया गया",
  "totalNews": "कुल समाचार",
  "totalPL": "कुल लाभ/हानि",
  "totalValue": "कुल मूल्य",
  "totalWhaleVolume": "कुल व्हेल वॉल्यूम",
  "tradeSetup": "ट्रेड सेटअप",
  "transferVolume": "स्थानांतरण वॉल्यूम",
  "trend": "ट्रेंड",
  "trendStrength": "रुझान शक्ति",
  "upperPrice": "ऊपरी मूल्य",
  "usdValue": "USD मूल्य",
  "viewDetails": "विवरण देखें",
  "volatility": "अस्थिरता",
  "volatilityIndex": "वोलेटिलिटी इंडेक्स",
  "weakTrend": "कमजोर रुझान",
  "whaleAccumulation": "व्हेल संचय",
  "whaleActivity": "व्हेल एक्टिविटी",
  "whaleAlertCreatedFor": "व्हेल अलर्ट बनाया गया इसके लिए",
  "whaleRisk": "Whale Risk",
  "whaleScore": "व्हेल स्कोर",
  "writeNewsSummary": "समाचार सारांश लिखें",
  "yearlyProfit": "वार्षिक लाभ"
}